import type { AxiosResponse } from 'axios';

const baseUrl = '/settings/adyen';

interface AdyenForm {
    [key: string]: unknown;
}

const getSettings = (): Promise<AxiosResponse> => {
    return ApiClient.get(baseUrl);
};

const saveSettings = (shouldUpdateSettings: boolean, form: AdyenForm): Promise<AxiosResponse> => {
    return shouldUpdateSettings
        ? ApiClient.put(baseUrl, {}, form)
        : ApiClient.post(baseUrl, {}, form);
};

export { getSettings, saveSettings };
